import React from "react";
import Button from "src/components/Button";
import AgreeTermsCheckbox from "src/components/form/AgreeTermsCheckbox";
import Input from "src/components/form/Input";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useProspect from "src/hooks/api/services/auth/useProspect";
import { EMAIL_DOMAINS } from "src/lib/constants";

interface CreateProspectFormProps extends Translation {}

const CreateProspectForm = ({ t }: CreateProspectFormProps) => {
	const { status, form, validate, actions } = useProspect();

	const convertEmailToWebsite = (email: string) => {
		const parts = email.split("@");
		if (parts?.length > 1) {
			const domain = parts[1];
			if (!EMAIL_DOMAINS.includes(domain) && !form.website) {
				const field = actions.getField("website");
				field.handleChange({
					target: {
						value: domain,
					},
				});
			}
		}
	};

	const getFormField = (name: string) => {
		const field = actions.getField(name);

		return {
			...field,
			handleBlur: (e: any) => {
				const value = e?.target?.value;
				if (value?.includes("@")) {
					convertEmailToWebsite(value);
				}
				field.handleBlur();
			},
			noMarginBottom: true,
			placeholder: t(`fields.${name}.placeholder`),
		};
	};

	const onSubmit = (e?: any) => {
		if (e) e.preventDefault();
		if (!validate.isValid) return;

		actions.create();
	};

	return (
		<form {...{ onSubmit }} className="flex flex-col gap-4">
			<Input {...getFormField("email")} type="email" />
			<Input {...getFormField("company_name")} />
			<Input {...getFormField("website")} optional />
			<AgreeTermsCheckbox
				className="my-2"
				value={form.agreed}
				onChange={() =>
					actions.setForm({
						agreed: form.agreed ? false : true,
					})
				}
			/>
			<Button
				loading={status !== "idle"}
				disabled={!form.agreed || !validate.isValid}
				submit
			>
				{t("buttons.signup")}
			</Button>
		</form>
	);
};

CreateProspectForm.locale = {
	nl: {
		fields: {
			email: {
				placeholder: "Email",
			},
			company_name: {
				placeholder: "Bedrijfsnaam",
			},
			website: {
				placeholder: "Website (optioneel)",
			},
		},
		buttons: {
			signup: "Doorgaan",
		},
	},
	en: {
		fields: {
			email: {
				placeholder: "Email",
			},
			company_name: {
				placeholder: "Company name",
			},
			website: {
				placeholder: "Website (optional)",
			},
		},
		buttons: {
			signup: "Continue",
		},
	},
};

export default withTranslation(CreateProspectForm);
